
import { menudb } from "./menudb.js";
import fondoMaderaGrande from '../../imagenes/fondoMaderaGrande.webp';
import fondoMaderaPequeno from '../../imagenes/fondoMaderaPequeno.webp';
const bdextras = [...menudb[0].extras];

function Extras() {
  return (
    <div
    id='extras'
    className="relative min-h-screen bg-cover bg-center bg-no-repeat px-6 text-white py-20 overflow-hidden flex flex-col items-center justify-center "
  >
    <p className='text-3xl pb-10'>EXTRAS</p>
    <div className='grid grid-cols-3 max-md:grid-cols-1 gap-2 md:gap-20'>
      <div className='relative w-[200px] h-[200px] flex items-center justify-center'>
        <div className='absolute  top-0 left-0'>
          <p className='w-[100px]'>{bdextras[0].name}</p>
          <p className='text-sm'>s/. {bdextras[0].price}</p>
        </div>
        <img src={require(`../../imagenes/extrasImage/${bdextras[0].image}-160-160.webp`)}  height={160} width={160} alt={bdextras[0].name} loading='lazy'/>
      </div>
      <div className='relative w-[200px] h-[200px] flex items-center justify-center'>
        <div className='absolute  top-0 right-0'>
          <p className='w-[100px]'>{bdextras[1].name}</p>
          <p className='text-sm'>s/. {bdextras[1].price}</p>
        </div>
        <img src={require(`../../imagenes/extrasImage/${bdextras[1].image}-160-160.webp`)}  height={160} width={160} alt={bdextras[1].name} loading='lazy'/>
      </div>
      <div className='relative w-[200px] h-[200px] flex items-center justify-center'>
        <div className='absolute  top-0 left-0'>
          <p className='w-[100px]'>{bdextras[2].name}</p>
          <p className='text-sm'>s/. {bdextras[2].price}</p>
        </div>
        <img src={require(`../../imagenes/extrasImage/${bdextras[2].image}-160-160.webp`)}  height={160} width={160} alt={bdextras[2].name} loading='lazy'/>
      </div>
      <div className="absolute bottom-0 right-0 w-full grid place-items-center h-[40px] bg-black/30 text-white">
          KoreanMania - Disfruta
        </div>
        <div className="absolute top-0 right-0 w-full grid place-items-center h-[40px] bg-black/30 text-white">
          KoreanMania - Descubre
        </div>
    </div>
     <style>
  {`
    @media (max-width: 768px){
      #extras{
        background-image: url(${fondoMaderaPequeno});
      }  
    }
    @media (min-width: 768px) {
      #extras {
        background-image: url(${fondoMaderaGrande});
      }
    }
  `}
</style></div>
  )
}

export default Extras